// src/hooks/useCheckLoginStatus.ts
import { useEffect, useState } from 'react';
import { getLoggedInUserProfile } from '../apps/user/Users/UserService'; // Adjust the path as needed

const useCheckLoginStatus = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const checkLoginStatus = async () => {
      try {
        await getLoggedInUserProfile();
        setIsLoggedIn(true);
      } catch {
        setIsLoggedIn(false);
      }
    };
    checkLoginStatus();
  }, []);

  return isLoggedIn;
};

export default useCheckLoginStatus;
